import { render } from "./DocViewNew.vue?vue&type=template&id=8d832f92&ts=true"
import script from "./DocViewNew.vue?vue&type=script&lang=tsx"
export * from "./DocViewNew.vue?vue&type=script&lang=tsx"

import exportComponent from "K:\\VoionContaract\\voion.contaract.clients\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__